exports.roles = Object.freeze({
  Seo: "Seo",
  Admin: "Admin",
  SchoolAdmin: "SchoolAdmin"
});

exports.itemSectionType = Object.freeze({
  Html: "html",
  Banner: "banner",
  Ad: "ad",
  Coloring: "coloring"
});